import { toProperCase } from '@core/utils/string';

export type EnumOption = {
  value: string;
  label: string;
};

export function getValues<T extends Record<string, string>>(
  enumObject: T
): string[] {
  return Object.values(enumObject);
}

export function getOptions<T extends Record<string, string>>(
  enumObject: T
): EnumOption[] {
  return getValues(enumObject).map((value) => ({
    value,
    label: value
      .split(/[_-]/)
      .filter(Boolean)
      .map((part) => toProperCase(part))
      .join(' '),
  }));
}
